export const getBasicData = state => state.basicData || {};
export const getViewMode = state => (getBasicData(state).viewMode || 'site').toLowerCase();
